import styled from 'styled-components';

const StyledContainer = styled.div`
	position: relative;
	width: 120px;
	height: 120px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	background-color: #202020;
`;

export { StyledContainer };
